module.exports = __webpack_public_path__ + "img/女.5e1a7ef9.png";